import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// CDK
import { ClipboardModule } from '@angular/cdk/clipboard';

// Material modules
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

// Shared
import { ElementsModule } from '@modules/elements/elements.module';

// Components
import { SettingsComponent } from './components/settings/settings.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ClipboardModule,

    // Material
    MatIconModule,
    MatTooltipModule,

    // Shared
    ElementsModule,
  ],
  declarations: [
    SettingsComponent,
  ],
  exports: [
    SettingsComponent,
  ],
})
export class SettingsModule { }
